import { createStore } from 'redux'
import thunk from 'redux-thunk'
import { persistStore } from 'redux-persist'
import rootReducer from './reducers/rootReducer'

const store = createStore(rootReducer)

export default store
export const persistor = persistStore(store)
